module.exports = __webpack_public_path__ + "media/src/assets/face-logo--blue-e78a364704defb4f1d72e948a1c8b66a.svg";